export default __webpack_public_path__ + "static/media/34.963031f2.jpg";